import { InputMasked } from 'twyne-new.ui';

import FormComponent from './FormComponent';

export default class MaskedInputForm extends FormComponent {
  static Pure = ({ onChange, ...props }) => <InputMasked {...props}
    onChange={evt => onChange(evt.target.value)}
  />
}
